export default __webpack_public_path__ + "static/media/Paragon knits Limited.a25fa52c.jpg";